import { get } from './ajax';

const siteUrl = window.location.origin;

const userImgUrl = ( imgUrl ) => {
    const defaultImage = '/assets/img/avatar-default.svg';
    return imgUrl ? imgUrl : siteUrl + defaultImage;
};

const userSlug = ( user ) => {
    const username = user.username ? user.username : user.s_user_name;
    return '/u/' + username;
}

const productUrl = (permalink) => `${siteUrl}/p/${permalink}`;

const userUrl = (username) => `${siteUrl}/u/${username}`;

const getUrlParam = ( param ) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    
    return urlParams.has( param ) ? urlParams.get( param ) : false;
};

const getProductUrl = async ( productId ) => {
    const product = await get( `/api/v5/products/${productId}` );
    return product.permalink;
};

export { userImgUrl, userSlug, getUrlParam,
    productUrl, getProductUrl, userUrl };
